import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.replace.js";
// Utils
import apiClient from "../api/api.utils";
import apiCbClient from "../api-cb/api-cb.utils";
import cookies from "../cookies/cookies";
// Constants
import apiClientConstants from "../../constants/api-client";
import constants from "./constants/session.constants";
import storageConstants from "../../constants/storage";
// Utilities
import { generateTimestamp, getCookieDomain } from "./utils/session.utils.utils";
// Types

var removeAndSaveOnCookie = function removeAndSaveOnCookie(_ref) {
  var name = _ref.name,
    value = _ref.value,
    domain = _ref.domain;
  cookies.getCookie(name) && cookies.removeCookie({
    id: name,
    domain: domain
  });
  value && name && cookies.setCookie({
    name: name,
    value: value,
    domain: domain
  });
  cookies.setCookie({
    name: storageConstants.COOKIES_IDS.ACCESS_TOKEN_ORIGIN,
    value: window.location.hostname,
    domain: domain
  });
};
var saveSessionData = function saveSessionData(_ref2) {
  var accessToken = _ref2.accessToken,
    domain = _ref2.domain,
    expiresIn = _ref2.expiresIn,
    refreshToken = _ref2.refreshToken,
    _ref2$saveCookiesAll = _ref2.saveCookiesAll,
    saveCookiesAll = _ref2$saveCookiesAll === void 0 ? false : _ref2$saveCookiesAll,
    username = _ref2.username;
  var currentDomain = domain || getCookieDomain();
  accessToken && removeAndSaveOnCookie({
    name: storageConstants.COOKIES_IDS.ACCESS_TOKEN,
    value: accessToken,
    domain: currentDomain
  });
  refreshToken && removeAndSaveOnCookie({
    name: storageConstants.COOKIES_IDS.REFRESH_TOKEN,
    value: refreshToken,
    domain: currentDomain
  });
  expiresIn && cookies.setCookie({
    name: storageConstants.LOCALSTORAGE_IDS.REFRESH_TOKEN_ALIVE,
    value: generateTimestamp(expiresIn).toString(),
    domain: currentDomain
  });
  if (saveCookiesAll) {
    username && removeAndSaveOnCookie({
      name: storageConstants.LOCALSTORAGE_IDS.USERNAME,
      value: username,
      domain: currentDomain
    });
    expiresIn && removeAndSaveOnCookie({
      name: storageConstants.LOCALSTORAGE_IDS.REFRESH_TOKEN_ALIVE,
      value: generateTimestamp(expiresIn).toString(),
      domain: currentDomain
    });
  }
};
var clearSessionData = function clearSessionData() {
  var _localStorage$getItem, _localStorage$getItem2;
  var userIsRemembered = localStorage.getItem(storageConstants.LOCALSTORAGE_IDS.REMEMBER_USER) === String(true);
  var username = (_localStorage$getItem = localStorage.getItem(storageConstants.LOCALSTORAGE_IDS.USERNAME)) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : '';
  var persistentData = (_localStorage$getItem2 = localStorage.getItem(storageConstants.LOCALSTORAGE_IDS.PERSISTENT_DATA)) !== null && _localStorage$getItem2 !== void 0 ? _localStorage$getItem2 : '';
  var domain = getCookieDomain();
  cookies.removeAllCookies(domain);
  localStorage.clear();
  sessionStorage.clear();
  persistentData && localStorage.setItem(storageConstants.LOCALSTORAGE_IDS.PERSISTENT_DATA, persistentData);
  if (!username) return;
  localStorage.setItem(storageConstants.LOCALSTORAGE_IDS.REMEMBER_USER, String(userIsRemembered));
  userIsRemembered && localStorage.setItem(storageConstants.LOCALSTORAGE_IDS.USERNAME, username);
};
var refreshToken = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _cookies$getCookie;
    var options,
      _options$isCb,
      isCb,
      _options$isGil,
      isGil,
      refreshToken,
      username,
      client,
      _yield$client$post,
      _yield$client$post2,
      response,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          _options$isCb = options.isCb, isCb = _options$isCb === void 0 ? false : _options$isCb, _options$isGil = options.isGil, isGil = _options$isGil === void 0 ? false : _options$isGil;
          refreshToken = cookies.getCookie(storageConstants.COOKIES_IDS.REFRESH_TOKEN), username = (_cookies$getCookie = cookies.getCookie(storageConstants.LOCALSTORAGE_IDS.USERNAME)) !== null && _cookies$getCookie !== void 0 ? _cookies$getCookie : localStorage.getItem(storageConstants.LOCALSTORAGE_IDS.USERNAME), client = isCb ? apiCbClient : apiClient;
          if (!(refreshToken && username)) {
            _context.next = 18;
            break;
          }
          _context.next = 6;
          return client.post(_objectSpread({
            endpoint: isCb ? constants.ENDPOINTS.REFRESH_TOKEN_CB : constants.ENDPOINTS.REFRESH_TOKEN,
            params: {
              refreshToken: refreshToken,
              username: username
            }
          }, isGil && {
            absoluteUrl: constants.REFRESH_TOKEN_LENDING_ABSOLUTE_URL,
            channel: apiClientConstants.CHANNELS.GIL
          }));
        case 6:
          _yield$client$post = _context.sent;
          _yield$client$post2 = _slicedToArray(_yield$client$post, 1);
          response = _yield$client$post2[0];
          if (!(response && response !== null && response !== void 0 && response.accessToken && response !== null && response !== void 0 && response.expiresIn)) {
            _context.next = 14;
            break;
          }
          saveSessionData(_objectSpread(_objectSpread({}, response), {}, {
            domain: getCookieDomain()
          }));
          return _context.abrupt("return", true);
        case 14:
          clearSessionData();
          return _context.abrupt("return", false);
        case 16:
          _context.next = 19;
          break;
        case 18:
          return _context.abrupt("return", false);
        case 19:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function refreshToken() {
    return _ref3.apply(this, arguments);
  };
}();
var isUserLogged = function isUserLogged() {
  return !!cookies.getCookie(storageConstants.COOKIES_IDS.ACCESS_TOKEN) && !!cookies.getCookie(storageConstants.COOKIES_IDS.REFRESH_TOKEN);
};
var isUserAgentLogged = function isUserAgentLogged() {
  return !!cookies.getCookie(storageConstants.COOKIES_IDS.ACCESS_TOKEN) && !!cookies.getCookie(storageConstants.COOKIES_IDS.AGENT_TOKEN) && !!cookies.getCookie(storageConstants.COOKIES_IDS.REFRESH_TOKEN);
};
var logout = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var domain, accessToken, rememberUser, username;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          domain = getCookieDomain();
          accessToken = cookies.getCookie(storageConstants.COOKIES_IDS.ACCESS_TOKEN), rememberUser = cookies.getCookie(storageConstants.LOCALSTORAGE_IDS.REMEMBER_USER), username = cookies.getCookie(storageConstants.LOCALSTORAGE_IDS.USERNAME);
          if (!accessToken) {
            _context2.next = 10;
            break;
          }
          _context2.next = 5;
          return apiClient.post({
            endpoint: constants.ENDPOINTS.LOGOUT,
            params: {
              accessToken: accessToken
            }
          });
        case 5:
          clearSessionData();
          rememberUser && username && removeAndSaveOnCookie({
            name: storageConstants.LOCALSTORAGE_IDS.USERNAME,
            value: username,
            domain: domain
          });
          window.location.replace('/');
          _context2.next = 12;
          break;
        case 10:
          clearSessionData();
          window.location.replace('/');
        case 12:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function logout() {
    return _ref4.apply(this, arguments);
  };
}();
var updateUserDataFromSingleUseToken = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(singleUseToken) {
    var _yield$apiClient$get, _yield$apiClient$get2, response;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if (!singleUseToken) {
            _context3.next = 14;
            break;
          }
          _context3.next = 3;
          return apiClient.get({
            endpoint: constants.ENDPOINTS.REFRESH_SESSION_DATA,
            hasCommonHeaders: false,
            customHeaders: {
              accessToken: singleUseToken
            }
          });
        case 3:
          _yield$apiClient$get = _context3.sent;
          _yield$apiClient$get2 = _slicedToArray(_yield$apiClient$get, 1);
          response = _yield$apiClient$get2[0];
          if (!(response !== null && response !== void 0 && response.accessToken)) {
            _context3.next = 11;
            break;
          }
          saveSessionData(_objectSpread(_objectSpread({}, response), {}, {
            domain: getCookieDomain(),
            secure: true
          }));
          return _context3.abrupt("return", true);
        case 11:
          return _context3.abrupt("return", false);
        case 12:
          _context3.next = 15;
          break;
        case 14:
          return _context3.abrupt("return", false);
        case 15:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function updateUserDataFromSingleUseToken(_x) {
    return _ref5.apply(this, arguments);
  };
}();
export default {
  clearSessionData: clearSessionData,
  isUserLogged: isUserLogged,
  isUserAgentLogged: isUserAgentLogged,
  logout: logout,
  refreshToken: refreshToken,
  saveSessionData: saveSessionData,
  updateUserDataFromSingleUseToken: updateUserDataFromSingleUseToken
};